import { Product } from 'generated/graphql';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { ConsultantCategoryProductList } from './ConsultantCategoryProductList';

type ConsultantCategoryProps = {
    organisationId: number;
    products: Product[];
    title: string;
};

export function ConsultantCategory({ organisationId, products, title }: ConsultantCategoryProps) {
    const { t } = useServerTranslation();

    return (
        <>
            <Typography
                variant="h2"
                fontWeight="bold"
                sx={{ marginBottom: 3 }}
            >
                {title}
            </Typography>
            <Stack direction="row" flexWrap="wrap" gap={4} sx={{ marginBottom: '50px' }}>
                <ConsultantCategoryProductList
                    products={products}
                    itemBoxProps={{
                        width: '240px',
                        marginX: 'unset',
                    }}
                />
            </Stack>
        </>
    );
}
